import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * @file Created on 19.7.2020
 * @author MHl
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { SiteReleaseTerminationConverter, jsonConversions, SiteReleaseTerminationUploadConverter, SiteReleaseTerminationItemConverter } from '@logio/common-be-fe';
import { CONSTANTS } from '../../../constants';
import api from '../../api';
import { Inject } from '@logio/typescript-ioc';
import logger from '../../logger';
export var RegularSiteTerminationLayer =
/*#__PURE__*/
function () {
  function RegularSiteTerminationLayer() {
    _classCallCheck(this, RegularSiteTerminationLayer);
  }

  _createClass(RegularSiteTerminationLayer, [{
    key: "getTerminations",
    // terminations page

    /**
     * Gets the list of all overviews of sellout prices termination
     */
    value: function getTerminations() {
      var _this = this;

      return api(CONSTANTS.API.ENDPOINTS.REGULAR_SITE_TERMINATIONS).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this.SiteReleaseTerminationConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    } // upload terminations

  }, {
    key: "getUpload",
    value: function getUpload(id) {
      var _this2 = this;

      return api(CONSTANTS.API.ENDPOINTS.REGULAR_SITE_TERMINATION_UPLOADS_ID(id)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this2.SiteReleaseTerminationUploadConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(terminationName, terminationFile) {
      var _this3 = this;

      var data = new FormData();
      data.append('name', terminationName);
      data.append('file', terminationFile.data);
      return api(CONSTANTS.API.ENDPOINTS.REGULAR_SITE_TERMINATION_UPLOADS_FILE).post(data, {
        responseType: 'json'
      }).then(function (response) {
        return _this3.SiteReleaseTerminationUploadConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    } // termination detail

  }, {
    key: "getTerminationById",
    value: function getTerminationById(id) {
      var _this4 = this;

      return api(CONSTANTS.API.ENDPOINTS.REGULAR_SITE_TERMINATIONS_ID(id)).get({
        responseType: 'json'
      }).then(function (response) {
        return _this4.SiteReleaseTerminationConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "getTerminationItems",
    value: function getTerminationItems(id) {
      var _this5 = this;

      return api(CONSTANTS.API.ENDPOINTS.REGULAR_SITE_TERMINATIONS_ITEMS(id)).get({
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this5.SiteReleaseTerminationItemConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "confirmTermination",
    value: function confirmTermination(terminationId) {
      var _this6 = this;

      return api(CONSTANTS.API.ENDPOINTS.REGULAR_SITE_TERMINATIONS_CONFIRMATION(terminationId)).post({
        id: terminationId
      }, {
        responseType: 'json'
      }).then(function (response) {
        return _this6.SiteReleaseTerminationConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "cancelTermination",
    value: function cancelTermination(terminationId) {
      var _this7 = this;

      return api(CONSTANTS.API.ENDPOINTS.REGULAR_SITE_TERMINATIONS_CANCELL(terminationId)).patch({
        id: terminationId
      }, {
        responseType: 'json'
      }).then(function (response) {
        return _this7.SiteReleaseTerminationConverter.toObject(response.data, jsonConversions);
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "updateTerminationItemTerminate",
    value: function updateTerminationItemTerminate(data) {
      var _this8 = this;

      return api(CONSTANTS.API.ENDPOINTS.REGULAR_SITE_TERMINATION_ITEMS_TERMINATE).patch({
        data: data
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this8.SiteReleaseTerminationItemConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }, {
    key: "updateTerminationItemDate",
    value: function updateTerminationItemDate(data) {
      var _this9 = this;

      var parsedData = [];
      data.forEach(function (d) {
        return parsedData.push({
          id: d.id,
          pValidTo: d.pValidTo.format('YYYY-MM-DD')
        });
      });
      return api(CONSTANTS.API.ENDPOINTS.REGULAR_SITE_TERMINATION_ITEMS_TERMINATE_DATE).patch({
        data: [].concat(parsedData)
      }, {
        responseType: 'json'
      }).then(function (response) {
        var arr = [];
        (response.data.result || []).map(function (item) {
          arr.push(_this9.SiteReleaseTerminationItemConverter.toObject(item, jsonConversions));
        });
        return arr;
      }).catch(function (error) {
        logger.error(error);
        return Promise.reject(error);
      });
    }
  }]);

  return RegularSiteTerminationLayer;
}();

__decorate([Inject, __metadata("design:type", SiteReleaseTerminationConverter)], RegularSiteTerminationLayer.prototype, "SiteReleaseTerminationConverter", void 0);

__decorate([Inject, __metadata("design:type", SiteReleaseTerminationItemConverter)], RegularSiteTerminationLayer.prototype, "SiteReleaseTerminationItemConverter", void 0);

__decorate([Inject, __metadata("design:type", SiteReleaseTerminationUploadConverter)], RegularSiteTerminationLayer.prototype, "SiteReleaseTerminationUploadConverter", void 0);